import { generalSize } from '@xti-external/frontend-kit-components'

export const INPUT_LABEL_SIZE_MAPPING = {
  [generalSize.lg]: generalSize.sm,
  [generalSize.md]: generalSize.sm,
  [generalSize.sm]: generalSize.xs,
}

export default INPUT_LABEL_SIZE_MAPPING
